/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.BaseUnitTypeResponseDto>
>;
export function request(
  params: API.basics.baseUnitType.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseUnitType/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
